import { varAlpha } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------

export function GradientText({ textDefault, txtGradient, sx, ...other }) {
  return (
    <Typography sx={[...(Array.isArray(sx) ? sx : [sx])]} {...other}>
      {textDefault}

      <Box
        component="span"
        sx={(theme) => ({
          ml: 1,
          ...theme.mixins.textGradient(
            `to right, ${theme.vars.palette.primary.main}, ${varAlpha(theme.vars.palette.primary.darkerChannel, 0.9)}`
          ),
        })}
      >
        {txtGradient}
      </Box>
    </Typography>
  );
}
